export default "__VITE_ASSET__D$XPPe9y__"